import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import MachineryForm from './shared/MachineryForm';
import useMachineryPageForm from '../../../hooks/useMachineryPageForm';

interface MachineryListContext {
    refresh: () => void;
}

const MachineryAssetPageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<MachineryListContext>();

    const handleClose = () => navigate('/collateral/machineries');

    const handleSuccess = () => {
        toast.success('Maquinário cadastrado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useMachineryPageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="machinery-asset-form"
            show={true}
            onClose={handleClose}
            header="Novo Maquinário"
            size="lg"
            body={<MachineryForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default MachineryAssetPageForm;
